var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{staticStyle:{"height":"440px"},attrs:{"id":_vm.id,"name":_vm.id,"rows":"10","cols":"30","aria-label":"editor"}},[_vm._v(" "+_vm._s(_vm.texto)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }